import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { PureComponent, Fragment } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { FriendbuyWidget } from 'components/Friendbuy/FriendbuyWidget';
import { decorateWith } from 'helpers/decorator';
import { isEmpty } from 'helpers/verify';
import { deepExtract } from 'helpers/deep';
import { userProfile } from 'redux/saga/entities/bound';
export var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ref = userProfile.data(state) || ownProps.user || {},
      rafInfo = _ref.friendbuy_info,
      id = _ref.id,
      email = _ref.email,
      msa = _ref.msa;

  return {
    email: email,
    loaded: !isEmpty(rafInfo),
    userId: id,
    countryCode: deepExtract('country_code', msa, 'USA'),
    widgetCode: rafInfo && rafInfo.widget_code
  };
};
export var ShowFriendbuyWidgetUnwrapped =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ShowFriendbuyWidgetUnwrapped, _PureComponent);

  function ShowFriendbuyWidgetUnwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ShowFriendbuyWidgetUnwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ShowFriendbuyWidgetUnwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      e.stopPropagation();
      var onClick = _this.props.onClick;

      _this.setState({
        open: true
      });

      if (onClick) {
        onClick();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFriendbuyWidgetClose", function () {
      return _this.setState({
        open: false
      });
    });

    return _this;
  }

  _createClass(ShowFriendbuyWidgetUnwrapped, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          email = _this$props.email,
          intl = _this$props.intl,
          loaded = _this$props.loaded,
          userId = _this$props.userId,
          countryCode = _this$props.countryCode,
          widgetCode = _this$props.widgetCode;
      return loaded && React.createElement(Fragment, null, React.createElement("a", {
        className: className,
        onClick: this.handleClick
      }, children), this.state.open && React.createElement(FriendbuyWidget, {
        countryCode: countryCode,
        userId: userId,
        email: email,
        intl: intl,
        widgetCode: widgetCode,
        onClose: this.handleFriendbuyWidgetClose
      }));
    }
  }]);

  return ShowFriendbuyWidgetUnwrapped;
}(PureComponent);
ShowFriendbuyWidgetUnwrapped.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  email: PropTypes.string,
  intl: intlShape,
  loaded: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  userId: PropTypes.number,
  countryCode: PropTypes.string,
  widgetCode: PropTypes.string
};
export var ShowFriendbuyWidget = decorateWith(connect(mapStateToProps), injectIntl)(ShowFriendbuyWidgetUnwrapped);